import { useEffect, useRef } from "react";

export default function SmartVideo({ src }) {
  const ref = useRef(null);

  useEffect(() => {
    const video = ref.current;
    if (!video) return;

    const handlePlay = async () => {
      try {
        await video.play();
      } catch (err) {
        // Suppress harmless autoplay interruption warnings
        if (err.name !== "AbortError") {
          console.warn("Video play prevented:", err);
        }
      }
    };

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        handlePlay();
      } else {
        video.pause();
      }
    });

    observer.observe(video);

    return () => observer.disconnect();
  }, []);

  return (
    <div className="exampleVideo_videoDiv">
      <video ref={ref} src={src} muted loop preload="none" className="exampleVideo_video"/>
    </div>
  )
  
}
